import * as React from 'react'
import {compose} from 'recompose'
import {StoreType} from 'admin/models/Store'
import {reaction} from 'mobx'
import {inject} from 'mobx-react'

type OuterProps = {}
export type InnerProps = OuterProps & {
  store: StoreType
}

class Loader extends React.Component<InnerProps> {
  globalLoader = document.querySelector('#global-loader')

  componentDidMount () {
    const {ui} = this.props.store

    reaction(() => ui.globalLoader, () => {
      if (ui.globalLoader) {
        this.globalLoader!.className = ''
      } else {
        this.globalLoader!.className = 'global-loader-hidden'
      }
    }, {fireImmediately: true})
  }
  render () {
    return null
  }
}

export default compose<InnerProps, OuterProps>(
  inject('store')
)(Loader)
